<template>
  <div class="navi clear">
    <div class="wrap">
      <ul class="top clear float-right">
        <li>
          <span @click="logout()" class="col-gray" style="cursor: pointer"
            >logout</span
          >
        </li>
      </ul>
      <div class="clear">
        <h1 class="dp-inblock">
          <a href="/intro" v-if="!is_how">
            <!-- <img src="../assets/img/logo-blue.png" alt="CARROT ELP"> -->
            <span class="font-20 bold" style="color: #53caff">My Class</span>
          </a>
          <a href="/intro" v-if="is_how">
            <img src="../assets/img/how/logo_on.png" alt="CARROT ELP" />
          </a>
        </h1>
        <!-- class="active" -->
        <ul class="bottom clear" v-if="!is_how">
          <li class="title">
            <a href="/intro" :class="{ active: target == '/intro' }"
              ><span>Class 현황</span></a
            >
          </li>

          <li class="title">
            <a
              href="https://carrotfarm.carrotenglish.com/dailySnack/dailyContent/reuterNewsList?viewGnb=N"
              target="_blank"
              ><span>REUTERs News</span></a
            >
          </li>
          <li class="title" v-if="is_global">
            <a
              :href="
                'https://' +
                  target_url +
                  '/lnk/carrot1121?id=' +
                  target_id +
                  '&accesscode=samsung21&ds=' +
                  target_ds
              "
              target="_blank"
              ><span>수강신청하기</span></a
            >
          </li>
          <li class="title" v-if="is_global">
            <a href="http://www.thespac.net/new/" target="_blank"
              ><span>평가결과확인하기</span></a
            >
          </li>
          <li class="title">
            <a href="/myinfo" :class="{ active: target == '/myinfo' }"
              ><span>My Info</span></a
            >
          </li>
          <li class="title">
            <a href="https://ecarrothouse.com/" target="_blank"
              ><span>교재 MP3</span></a
            >
          </li>
        </ul>

        <ul class="bottom clear" v-if="is_how" style="margin-top: -46px">
          <li class="title">
            <a href="/intro" :class="{ active: target == '/intro' }"
              ><span>My Class</span></a
            >
          </li>

          <li class="title">
            <a
              href="https://carrotfarm.carrotenglish.com/dailySnack/dailyContent/reuterNewsList?viewGnb=N"
              target="_blank"
              ><span>REUTERs News</span></a
            >
          </li>
          <li class="title">
            <a href="/myinfo" :class="{ active: target == '/myinfo' }"
              ><span>My Info</span></a
            >
          </li>
          <li class="title">
            <a href="https://ecarrothouse.com/" target="_blank"
              ><span>교재 MP3</span></a
            >
          </li>
        </ul>
        <img
          src="../assets/img/m-navi-toggle.png"
          class="m-navi-toggle"
          @click="showMenu()"
        />
      </div>
    </div>

    <div class="m-navi" v-show="mobileMenu" id="mobile_menu">
      <div class="top">
        <div class="wrap">
          <a class="float-right navi-close" @click="menuClose">
            <img src="../assets/img/modal-close-black.png" alt="" />
          </a>
          <p class="clear">
            {{ member.kname }}
            <span>{{ member.email }}</span>
          </p>
        </div>
      </div>
      <div class="wrap">
        <ul class="list">
          <li>
            <a href="/intro">
              My Class <span class="col-gray font-14">나의 수업 확인하기</span>
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
              />
            </a>
          </li>

          <li>
            <a
              href="https://carrotfarm.carrotenglish.com/dailySnack/dailyContent/reuterNewsList?viewGnb=N"
              target="_blank"
            >
              REUTERs News
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
              />
            </a>
          </li>
          <li v-if="!is_how">
            <a href="/untacttest">
              Untact 수업 환경 Test
              <span class="col-gray font-14">Untact 수업 준비</span>
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
                style="cursor: pointer"
              />
            </a>
          </li>
          <li>
            <a
              :href="
                'https://' +
                  target_url +
                  '/lnk/carrot1121?id=' +
                  target_id +
                  '&accesscode=samsung21&ds=' +
                  target_ds
              "
              target="_blank"
            >
              수강신청하기
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
                style="cursor: pointer"
              />
            </a>
          </li>
          <li v-if="is_global">
            <a href="http://www.thespac.net/new/" target="_blank">
              평가결과확인하기
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
                style="cursor: pointer"
              />
            </a>
          </li>
          <li v-if="is_global">
            <a href="/myinfo">
              My Info <span class="col-gray font-14">내 정보 수정</span>
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
              />
            </a>
          </li>
          <li>
            <a
              href="#"
              onclick="return false;"
              class="col-gray normal"
              @click="logout()"
            >
              로그아웃
              <img
                src="../assets/img/arrow-right-gray.png"
                alt=""
                class="float-right"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import router from "@/router";
export default {
  name: "incHead",
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false,
    },
  },

  data: function() {
    return {
      mobileMenu: false,
      member: {
        kname: "",
        email: "",
      },
      target: "",
      is_how: false,
      is_global: false,
      target_id: "",
      target_ds: "",
      target_url: "",
      isShow: true,
      isHidden: false,
    };
  },
  created() {
    if (location.hostname == "stagest.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stagestapi.carrotenglish.net");
    } else if (location.hostname == "st.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.hostname == "student.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.hostname == "m.carrotenglish.net") {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    } else if (location.href.includes("how")) {
      if (location.href.includes("stage")) {
        this.$store.commit(
          "changeHost",
          "https://stagestapi.carrotenglish.net",
        );
      } else {
        this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
      }
    } else {
      this.$store.commit("changeHost", "https://stapi.carrotenglish.net");
    }
  },
  mounted() {
    this.getMember();
    // alert(window.location.pathname);
    this.target = window.location.pathname;
    if (location.href.includes("1027") || location.href.includes("how")) {
      this.is_how = true;
    } else {
      this.is_how = false;
    }
    console.log("how" + this.is_how);
  },

  methods: {
    getMember() {
      var params = {
        uidx: localStorage.getItem("uidx"),
        accessKey: localStorage.getItem("accessKey"),
      };
      var me = this;
      // this.axios.get(this.$store.state.host + '/rest/mobile/getMember', {
      //     params: params
      // }).then(function (res) {
      //     // console.log(res.data.member);
      //     me.member = res.data.member;
      //     console.log(me.member);
      // });

      var formData = new FormData();
      formData.append("uidx", params.uidx);
      formData.append("accessKey", params.accessKey);

      console.log("localstorage_idx", localStorage.getItem("uidx"));
      console.log("localstorage_akey", localStorage.getItem("accessKey"));
      this.axios
        .post(this.$store.state.host + "/rest/mobile/getMember", formData)
        .then(function(res) {
          me.member = res.data.member;

          me.is_global = false;
          me.target_id = "";

          console.log(me.is_global);
          console.log(me.member);
          if (res.data.err == 213) {
            alert(res.data.err_msg);
            router.push("/login");
          }
        });
    },
    logout() {
      var accessToken = localStorage.getItem("accessToken");
      var accessKey = localStorage.getItem("accessKey");
      store
        .dispatch("LOGOUT", {
          accessToken,
          accessKey,
        })
        .then(() => {
          if (this.is_how) {
            this.$router.push("/how_intro");
          } else {
            if (sessionStorage.getItem("type") == "app") {
              location.href = "http://carrot.com";
            } else {
              this.$router.push("/login");
            }
          }
          // console.log(sessionStorage.getItem("type"));
        });
      // alert("a");
    },
    showMenu() {
      this.mobileMenu = true;
    },
    menuClose() {
      this.mobileMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap");

$point-color: #53caff;
$purple: #6974ff;
$gray: #b7b7b7;
$border-color: #e9e9e9;
$back-gray: #f5f5f5;

// 결석
$absent: #ff4068;
// 출석
$attend: #53caff;
// 휴강
$cancel: #ffb055;
// 예정
$scheduled: #e1e1e1;
// 공결
$reasons: #2feecd;

.navi {
  width: 100%;
  border-bottom: 1px solid $border-color;
  padding-bottom: 20px;
  position: relative;
  z-index: 50;
  .wrap {
    max-width: 1200px;
  }

  .top {
    li {
      display: inline-block;
      padding: 10px;
      font-size: 14px;

      &:last-child {
        padding-right: 0;
      }
    }
  }

  .bottom {
    float: right;
    width: 85%;
    text-align: right;

    .title {
      font-size: 18px;
      vertical-align: top;
      display: inline-block;
      padding-right: 30px;

      span:hover {
        font-weight: bold;
        color: #53caff;
      }

      &:last-child {
        padding-right: 0;
      }

      a.active {
        color: $point-color;
        font-weight: bold;
      }
    }

    .dept {
      display: none;
      padding: 20px 0 0 0;

      li {
        float: none;
        padding-bottom: 15px;
        font-size: 16px;

        a {
          color: #9b9b9b;

          &:hover {
            color: #000000;
          }
        }

        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
}

.m-navi-toggle {
  display: none;
}

.m-navi {
  // display: none;
}

@media only screen and (max-width: 768px) {
  // 네비
  .navi {
    padding-top: 20px;
    position: absolute;
    border-bottom: none;
    z-index: 50;
    .top {
      display: none;
    }

    .bottom {
      display: none;
    }
  }

  .m-navi-toggle {
    display: block;
    float: right;
  }

  .m-navi {
    position: fixed;
    background: #ffffff;
    width: 100%;
    height: 100%;
    z-index: 999;
    padding: 0px 0 50px 0;
    top: 0;

    .top {
      margin-bottom: 20px;
      background: white;
      padding-top: 20px;
      display: block;
      padding: 20px;
      padding-bottom: 0;
      .wrap {
        border-bottom: 2px solid #e9e9e9;
      }
      p {
        font-weight: bold;
        font-size: 28px;
        padding-bottom: 20px;
        color: #000000;

        span {
          color: #b7b7b7;
          font-weight: 200;
          font-size: 16px;
          display: block;
          margin-top: 10px;
        }
      }

      li {
        display: inline-block;
        width: calc(100% / 3 - 4px);
        text-align: center;

        img {
          display: block;
          margin: 0 auto;
          opacity: 1;
        }
      }
    }

    .list {
      padding: 20px;
      border-bottom: 1px solid $border-color;

      &:last-child {
        border-bottom: none;
      }

      li {
        padding: 15px 0;
        font-weight: bold;
        cursor: pointer;

        a {
          display: block;
        }

        img {
          padding-top: 5px;
        }

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          padding-bottom: 0;
        }

        span {
          margin-left: 5px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
